import { frontendURL } from '../../../../helper/URLHelper';

import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

import Index from './Index.vue';
import Content from './Content.vue';
import SchemaTool from './SchemaTool.vue';
import SearchTool from './SearchTool.vue';
import EvalTool from './EvalTool.vue';
import Tools from './Tools.vue';
import IndexingTool from './IndexingTool.vue';
import MarkdownEditor from './MarkdownEditor.vue';
import NearbySearchTool from './NearbySearchTool.vue';
import ItineraryTool from './ItineraryTool.vue';
import RecordsTool from './RecordsTool.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/knowledgebases'),
      component: SettingsWrapper,
      props: {
        headerTitle: 'LIBRARIES.HEADER',
        icon: 'book',
      },
      children: [
        {
          path: '',
          name: 'settings_knowledgebases_index',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/knowledgebase/:knowledgebaseId'
      ),
      component: SettingsContent,
      props: () => {
        return {
          fullWidth: true,
          fixedHeight: true,
        };
      },
      children: [
        {
          path: '',
          name: 'settings_knowledgebases_content',
          component: Content,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'editor',
          name: 'settings_knowledgebases_markdown_editor',
          component: MarkdownEditor,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({
            knowledgebaseId: String(route.params.knowledgebaseId),
          }),
        },
        {
          path: ':recordId/editor',
          name: 'settings_knowledgebases_record_markdown_editor',
          component: MarkdownEditor,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({
            knowledgebaseId: String(route.params.knowledgebaseId),
            recordId: String(route.params.recordId),
          }),
        },
        {
          path: 'tools',
          name: 'settings_knowledgebases_tools',
          component: Tools,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({
            knowledgebaseId: String(route.params.knowledgebaseId),
          }),
        },
        {
          path: 'schema',
          name: 'settings_knowledgebases_schema',
          component: SchemaTool,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({
            knowledgebaseId: String(route.params.knowledgebaseId),
          }),
        },
        {
          path: 'indexing',
          name: 'settings_knowledgebases_indexing',
          component: IndexingTool,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({
            knowledgebaseId: String(route.params.knowledgebaseId),
          }),
        },
        {
          path: 'search',
          name: 'settings_knowledgebases_search',
          component: SearchTool,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({
            knowledgebaseId: String(route.params.knowledgebaseId),
          }),
        },
        {
          path: 'eval',
          name: 'settings_knowledgebases_eval',
          component: EvalTool,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({
            knowledgebaseId: String(route.params.knowledgebaseId),
          }),
        },
        {
          path: 'nearby',
          name: 'settings_knowledgebases_nearby',
          component: NearbySearchTool,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({
            knowledgebaseId: String(route.params.knowledgebaseId),
          }),
        },
        {
          path: 'itinerary',
          name: 'settings_knowledgebases_itinerary',
          component: ItineraryTool,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({
            knowledgebaseId: String(route.params.knowledgebaseId),
          }),
        },
        {
          path: 'records',
          name: 'settings_knowledgebases_records',
          component: RecordsTool,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({
            knowledgebaseId: String(route.params.knowledgebaseId),
          }),
        },
      ],
    },
  ],
};
